module.exports = __webpack_public_path__ + "img/chapter.ec3d937e.png";